import PropTypes from "prop-types";
import { forwardRef } from "react";

const CustomMoreOptions = forwardRef(
  (
    {
      onClick,
      variant = "outlined",
      orientation = "horizontal",
      color = "black",
      size = "medium",
    },
    ref
  ) => {
    const getSizeDimensions = () => {
      switch (size) {
        case "small":
          return "w-1 h-1";
        case "large":
          return "w-2 h-2";
        case "xlarge":
          return "w-2.5 h-2.5";
        case "medium":
        default:
          return "w-1.5 h-1.5";
      }
    };

    const dotSize = getSizeDimensions();

    return (
      <div
        ref={ref}
        onClick={onClick}
        className={`flex ${
          orientation === "vertical" ? "flex-col" : ""
        } gap-1 items-center p-2 cursor-pointer rounded-full transition-colors`}>
        {variant === "filled" ? (
          <>
            <div className={`${dotSize} rounded-full bg-${color}`}></div>
            <div className={`${dotSize} rounded-full bg-${color}`}></div>
            <div className={`${dotSize} rounded-full bg-${color}`}></div>
          </>
        ) : (
          <>
            <div
              className={`${dotSize} rounded-full border-2 border-${color}`}></div>
            <div
              className={`${dotSize} rounded-full border-2 border-${color}`}></div>
            <div
              className={`${dotSize} rounded-full border-2 border-${color}`}></div>
          </>
        )}
      </div>
    );
  }
);

CustomMoreOptions.displayName = "CustomMoreOptions";

CustomMoreOptions.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(["filled", "outlined"]),
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  color: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large", "xlarge"]),
};

export default CustomMoreOptions;
